module.exports = __webpack_public_path__ + "statics/img/logos.95da891b.png";